import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=228df3af&scoped=true"
var script = {}
import style0 from "./welcome.vue?vue&type=style&index=0&id=228df3af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228df3af",
  null
  
)

export default component.exports